var _g;

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBadgeBad(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return _g || (_g = /*#__PURE__*/React.createElement("g", {
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    width: 46,
    height: 46,
    rx: 23,
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.7756 36.9996C22.0265 34.8733 23.544 32.8439 24.6472 30.8579C25.7504 28.8718 25.5314 27.3819 23.2922 27.1579C20.4091 26.7996 19.2714 27.075 17.0862 26.6018C14.7704 26.1003 14.4209 25.237 14.4258 24.5833C14.4896 23.6815 15.1098 23.2941 15.2188 22.7909C15.3267 22.2926 13.4517 21.6257 13.804 19.9987C14.1828 18.2496 15.6985 18.7057 15.8064 18.2073C15.9154 17.7041 14.6833 17.1765 14.9806 15.8035C15.279 14.4257 17.1099 14.6892 17.2453 14.0638C17.3807 13.4385 16.7642 13.1771 16.9535 12.3025C17.144 11.4231 19.3486 9.93634 25.7785 11.3287C36.6819 13.8226 34.8542 16.0457 39.9982 17.1596L37.9669 26.5403C35.2643 25.9551 34.9072 28.2357 32.7301 29.5954C30.5204 31.0811 27.1851 34.6809 25.865 37.6686C24.8874 39.6819 23.1753 38.2626 22.7756 36.9996L22.7756 36.9996Z",
    fill: "#E36667"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeBad);
export default __webpack_public_path__ + "static/media/badge_bad.956a9307.svg";
export { ForwardRef as ReactComponent };